var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.120361,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#5AB949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2399 45.8511C37.8912 45.8511 46.5258 37.2165 46.5258 26.5652C46.5258 15.9139 37.8912 7.2793 27.2399 7.2793C16.5886 7.2793 7.95398 15.9139 7.95398 26.5652C7.95398 37.2165 16.5886 45.8511 27.2399 45.8511Z",
    fill: "#50B651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.663,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4668 26.511C46.4668 37.1958 37.8052 45.8574 27.1228 45.8574C16.4404 45.8574 7.77637 37.1958 7.77637 26.511C7.77637 21.7844 7.90885 21.0817 9.76933 18.3908C9.76933 18.3908 9.67333 21.4302 11.902 23.2388C13.2877 24.3625 14.734 23.5513 17.3812 22.3321C20.2448 21.0121 22.5728 20.1606 24.3892 20.3852C27.1252 20.7241 35.5583 25.7886 39.9594 24.7801C43.4754 23.9761 43.1044 15.6865 43.1044 15.6865C46.9444 19.4363 46.4668 21.9707 46.4668 26.511Z",
    fill: "url(#paint0_linear_24998_299676)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.586,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4244 40.7212C42.4212 34.1398 43.5842 26.6 38.9135 18.1017C38.9372 18.119 39.2261 17.1219 39.7804 15.1104C42.2661 18.1206 43.5879 21.8361 43.7457 26.2569C43.7444 31.983 40.9706 36.8044 35.4244 40.7212Z",
    fill: "url(#paint1_linear_24998_299676)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.744,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1056 15.1504C28.7284 13.2813 24.8538 9.52145 25.3688 8.73185C25.8839 7.94225 32.5688 8.07809 35.9466 9.94721C39.3244 11.8163 42.1991 17.4232 41.6845 18.2128C41.17 19.0024 35.4829 17.0195 32.1056 15.1504Z",
    fill: "url(#paint2_radial_24998_299676)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0475 31.3146C32.2458 31.3146 29.9744 28.9784 29.9744 26.097C29.9744 23.2156 32.2458 20.8799 35.0475 20.8799C37.8493 20.8799 40.1211 23.2156 40.1211 26.097C40.1211 28.9784 37.8498 31.3146 35.0475 31.3146ZM35.0835 29.6596C36.8322 29.6596 38.2515 28.0645 38.2515 26.097C38.2515 24.1295 36.8322 22.5359 35.0835 22.5359C33.3349 22.5359 31.9155 24.1309 31.9155 26.098C31.9155 28.065 33.3349 29.6596 35.0835 29.6596Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5802 16.6792H28.2359V31.2568H26.229V18.2781H24.5802V16.6792Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8557 21.0282H23.7532V33.2019C23.7532 34.3112 22.5863 35.4666 21.4492 35.9638C20.9116 36.1987 19.9196 36.3382 18.4732 36.3824V35.1714C19.8879 35.0136 20.8428 34.6989 21.3378 34.2272C21.6235 33.8302 21.802 33.3664 21.8562 32.8803V29.3038C21.349 30.38 20.7103 31.0934 19.9401 31.4442C19.1394 31.8762 17.5098 31.8051 16.8445 31.4442C16.1793 31.0832 15.2034 30.1328 14.7561 28.7173C14.6322 28.3266 14.3241 27.2634 14.3562 26.1368C14.385 25.064 14.7402 23.9288 15.0354 23.4622C15.5423 22.6654 16.3415 21.6675 17.5521 21.2504C18.1434 21.0466 19.2394 20.9733 20.8401 21.0306V22.2349C19.6506 22.1546 18.9085 22.1947 18.6138 22.3554C18.1717 22.5954 17.1738 22.8915 16.8445 25.0664C16.5153 27.2413 16.8541 29.0211 17.8981 29.5784C18.2557 29.7704 18.8884 29.9974 19.473 29.7973C20.5962 29.4133 21.6532 28.0438 21.7338 27.116C21.8151 26.1746 21.8557 24.1453 21.8557 21.0282Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8605 30.3831C44.0687 39.0111 36.4232 45.494 27.2644 45.494C16.7749 45.494 8.27124 36.9903 8.27124 26.5009C8.27124 19.9844 11.553 14.2345 16.5536 10.8145C12.4904 14.1841 9.90324 19.2745 9.90324 24.9668C9.90324 35.1202 18.1343 43.3508 28.2872 43.3508C36.5557 43.3508 43.5484 37.8927 45.8605 30.3831Z",
    fill: "url(#paint3_radial_24998_299676)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2643 4.00781C14.8419 4.00781 4.77106 14.0782 4.77106 26.5006C4.77106 38.923 14.8419 48.9939 27.2643 48.9939C39.6867 48.9939 49.7576 38.923 49.7576 26.5006C49.7576 14.0782 39.6867 4.00781 27.2643 4.00781ZM27.2643 45.4942C16.7749 45.4942 8.27122 36.9905 8.27122 26.5011C8.27122 19.9846 11.553 14.2347 16.5536 10.8147C19.7074 8.65472 23.4418 7.50161 27.2643 7.50749C37.7538 7.50749 46.2575 16.0107 46.2575 26.5006C46.2581 27.8049 46.1251 29.1057 45.8605 30.3829C44.0687 39.0109 36.4232 45.4937 27.2643 45.4937V45.4942Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24998_299676",
    x1: 26.3754,
    y1: 18.3284,
    x2: 28.8551,
    y2: 40.7219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E7C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5FBB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24998_299676",
    x1: 40.7008,
    y1: 16.8726,
    x2: 40.7008,
    y2: 34.9808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_24998_299676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.50936 4.29105 -2.03643 3.41829 33.9377 13.5992)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24998_299676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5212 22.1248) rotate(39.84) scale(21.3566 23.2787)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlo);
export default __webpack_public_path__ + "static/media/Glo.b38fd2d262b6824430160b66ec897281.svg";
export { ForwardRef as ReactComponent };